
$(function() {
    var h = $(window).height();
    $('#js-loader').height(h).css('display','block');
});


$(window).on('load',function () {
    $('#js-loader').delay(900).fadeOut(800);
    $('#loader').delay(600).fadeOut(300);
    $("#tw-container").twentytwenty({
        default_offset_pct: .72,
    });
    $("#tw-container-sp").twentytwenty({
        default_offset_pct: .5,
    });
});


//10遘偵◆縺｣縺溘ｉ蠑ｷ蛻ｶ逧�↓繝ｭ繝ｼ繝臥判髱｢繧帝撼陦ｨ遉ｺ
// $(function(){
//     setTimeout('stopload()',5000);
// });

function stopload(){
    $('#js-loader').delay(900).fadeOut(800);
    $('#loader').delay(600).fadeOut(300);
}

var h = $(window).height();
var w = $(window).width();
var st;

if(w > 900) {
    st = 'top 63px'
} else {
    st = 'top 48px;'
    $('.fv').height(h);
}

if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {


    gsap.utils.toArray("#fv").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top",
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                end: () => "+=" + section.offsetHeight,
                scrub: true,
                pin: true,
                anticipatePin: 1
            },
            defaults: {ease: "none"}
        });
        tl.fromTo(section.querySelector("#fv-bg"), {'transform': 'scale(8)'}, {'transform': 'scale(1)'})
            .fromTo(section.querySelector(".fv__txt"), {'opacity': "1"}, {'opacity': "0"})
        // .set('.about .about__txt', {className:"+=about__txt view-about is-show"});
        // .fromTo(document, {duration: 2, scrollTo: '#about'});
    });

    var src = $(window).scrollTop();
    $(window).scroll(function () {
        var scr = $(window).scrollTop();
        if(scr > $(window).height() * 2 + 160) {
            $('#fv-bg').addClass('wh');
        } else {
            $('#fv-bg').removeClass('wh');
        }
    })

} else {

    gsap.utils.toArray("#fv").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top",
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                end: () => "+=" + section.offsetHeight,
                scrub: true,
                pin: true,
                anticipatePin: 1
            },
            defaults: {ease: "none"}
        });
        tl.fromTo(section.querySelector("#fv-bg"), {'transform': 'scale(8)'}, {'transform': 'scale(1)'})
            .fromTo(section.querySelector(".fv__txt"), {'opacity': "1"}, {'opacity': "0"})
        // .set('.about .about__txt', {className:"+=about__txt view-about is-show"});
        // .fromTo(document, {duration: 2, scrollTo: '#about'});
    });

}




gsap.utils.toArray("#js-design").forEach(section => {
    let tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: st,
            // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
            // end: () => "+=" + section.offsetWidth,
            scrub: true,
            pin: true,
            anticipatePin: 1
        },
        defaults: {ease: "none"}
    });
    tl.fromTo(section.querySelector("#design01"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design02"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design03"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design04"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design05"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design06"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design07"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design08"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design09"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design10"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design11"), { height: "calc(100vh - 33px)"}, {height: 0})
        .fromTo(section.querySelector("#design12"), { height: "calc(100vh - 33px)"}, {height: 0})
        // .fromTo(section.querySelector("#design03"), { height: "100%"}, {height: "100%"})
});


if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {

    $('.fv').height(h);

}else {

    //Only Desktop
    gsap.utils.toArray(".c-area").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "center center",
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                // end: () => "+=" + section.offsetWidth,
                scrub: true,
                pin: true,
                anticipatePin: 1,
            },
            defaults: {ease: "none"}
        });
        tl.to(section, function (){})
    });

    gsap.utils.toArray("#feature01").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 93px",
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                // end: () => "+=" + section.offsetWidth,
                scrub: true,
                pin: true,
                anticipatePin: 1,
            },
            defaults: {ease: "none"}
        });

        tl.to(section, function (){})
        // animate the container one way...
        // ...and the image the opposite way (at the same time)
    });

    gsap.utils.toArray("#feature02").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 93px",
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                // end: () => "+=" + section.offsetWidth,
                scrub: true,
                pin: true,
                anticipatePin: 1,
            },
            defaults: {ease: "none"}
        });

        tl.to(section, function (){})
        // animate the container one way...
        // ...and the image the opposite way (at the same time)
    });




    gsap.utils.toArray("#safety_lead").forEach(section => {
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "center center",
                // makes the height of the scrolling (while pinning) match the width, thus the speed remains constant (vertical/horizontal)
                // end: () => "+=" + section.offsetWidth,
                scrub: true,
                pin: true,
                anticipatePin: 1,
            },
            defaults: {ease: "none"}
        });
        // animate the container one way...
        tl.fromTo(section.querySelectorAll("#safety_en, #safety_ja"), { opacity: 0},{ opacity: 1})
        // ...and the image the opposite way (at the same time)
    });


    ScrollReveal().reveal('.view', {
        duration: 2000,
        opacity: 1,
        viewFactor: 0.6,
        easing: 'ease',
        beforeReveal: function (el){
            el.classList.add('is-show');
        }
    });


    const image_s = document.getElementById("m_anim_img");
    var tmp_s = {};
    loadImageToTmp_s();
    function loadImageToTmp_s(){
        for(var i=1;i<=55;i++){
            const _i = i;
            const img = new Image();
            tmp_s[_i] = null;
            img.src = "https://xs791560.xsrv.jp/concept/images/m-area/0"+_i+".webp";
            // img.srcset = "bundles/web/img/concept/m-area/0"+_i+"@2x.webp";
            img.addEventListener("load",()=>{
                tmp_s[_i] = img;
            })
        }
    }


    var SIZE_s = 55;

    const offset_s = $("#m-area").offset();
    $('.m-area__txt-box--first').css({'opacity': 0});
    $('.m-area__txt-box--second').css({'opacity': 0});
    $(window).scroll(function() {
        const y = $(window).scrollTop()-($('.design').height()+$('.fv').parent('.pin-spacer').height()-$(window).height()+63);
        const dy = y - offset_s.top;
        //console.log('y:',y,'dy:',dy,'offset_s:',offset_s.top,'calc:',offset_s.top<y&&y<offset_s.top+SIZE_s*9)
        if(offset_s.top<y&&y<offset_s.top+SIZE_s*9){
            //console.log('True')
            $('.m-area__txt-box--first').css({'opacity': 1});
            setTimeout(function (){
                //console.log('set timeout')
                const i = Math.floor(dy / 9);
                if(i<=0||i>=SIZE_s) return;
                if (tmp_s[i].src) image_s.src = tmp_s[i].src;
                if(i>=40) {
                    $('.m-area__txt-box--first').css({'opacity': 0});
                    $('.m-area__txt-box--second').css({'opacity': 1});
                } else {
                    $('.m-area__txt-box--first').css({'opacity': 1});
                    $('.m-area__txt-box--second').css({'opacity': 0});
                }
            },200)
        }else if(y>=offset_s.top+SIZE_s*9){
            $("#m-area").css("top","-"+(dy-SIZE_s*9))
        }
    });

    $("#m_anim_img_padding").height(SIZE_s*18);


//陦晄茶
    var tmp_shock = {};
    loadImageToTmp_shock();
    function loadImageToTmp_shock(){
        for(var i=1;i<=176;i++){
            const _i = i;
            const img = new Image();
            tmp_shock[_i] = null;
            img.src = "https://xs791560.xsrv.jp/concept/images/shock/0"+_i+".webp";
            // img.srcset = "bundles/web/img/concept/shock/0"+_i+"@2x.webp";
            img.addEventListener("load",()=>{
                tmp_shock[_i] = img;
            })
        }
    }

    const image_shock = document.getElementById("s_anim_img");

    var SIZE_shock = 176;

    const offset_shock = $("#m-area-shock").offset();
    $(window).scroll(function() {
        const y = $(window).scrollTop()-($('.design').height()+$('.fv').parent('.pin-spacer').height()+$('.c-area').parent('.pin-spacer').height() - ($(window).height()*2));
        const dy = y - offset_shock.top;
        if(offset_shock.top<y&&y<offset_shock.top+SIZE_shock*16){
            const i = Math.floor(dy / 16);
            if(i<=0||i>=SIZE_shock) return;
            if(tmp_shock[i].src) image_shock.src = tmp_shock[i].src;
            if(i>=42) {
                $('.shock .view-ttl p').css({'transform': 'translate(0, 0)', 'opacity': 1});
                $('.shock .fadein_trg').css({'transform': 'translate(0, 0)', 'opacity': 1});
            } else {
                $('.shock .view-ttl p').css({'transform': 'translate(0, 30px)', 'opacity': 0});
                $('.shock .fadein_trg').css({'transform': 'translate(0, 30px)', 'opacity': 0});
            }
            // if(tmp_shock[i].srcset) image_shock.srcset = tmp_shock[i].srcset;
        }else if(y>=offset_shock.top+SIZE_shock*16){
            $("#m-area-shock").css("top","-"+(dy-SIZE_shock*16))
        }
    });

    $("#shock_anim_img_padding").height(SIZE_shock*21);



//螳峨ヴ繧ｫ
    var tmp_anpi = {};
    loadImageToTmp_anpi();
    function loadImageToTmp_anpi(){
        for(var i=1;i<=213;i++){
            const _i = i;
            const img = new Image();
            tmp_anpi[_i] = null;
            img.src = "https://xs791560.xsrv.jp/concept/images/safety/anpika/0"+_i+".webp";
            // img.srcset = "bundles/web/img/concept/shock/0"+_i+"@2x.webp";
            img.addEventListener("load",()=>{
                tmp_anpi[_i] = img;
            })
        }
    }

    const image_anpi = document.getElementById("safety_panel01_img");

    var SIZE_anpi = 213;

    const offset_anpi = $("#safety_panel_bg").offset();
    $(window).scroll(function() {
        const y = $(window).scrollTop()-($('.design').height()+$('.fv').parents('.pin-spacer').height()+$('.c-area').parents('.pin-spacer').height()+$('#safety_lead').parents('.pin-spacer').height()+$('#feature01').parents('.pin-spacer').height());
        const dy = y - offset_anpi.top;
        if(offset_anpi.top<y&&y<offset_anpi.top+SIZE_anpi*3){
            const i = Math.floor(dy / 3);
            if(i<=0||i>=SIZE_anpi) return;
            if(tmp_anpi[i].src) image_anpi.src = tmp_anpi[i].src;
            $('#safety_panel01_catch').css({'transform': 'translate(-50%, 140px)','opacity':0});
            $('#safety_panel_bg').css({'background': 'rgb(216,216,216)'});
            $('#safety_panel01_s').css({'opacity': 0});
            if(i>=28) {
                $('#safety_panel01_catch').css({'transform': 'translate(-50%, 80px)', 'opacity': 1});
                $('#safety_panel_bg').css({'background': 'rgb(32,32,32)'});
            } else {
                $('#safety_panel01_catch').css({'transform': 'translate(-50%, 140px)', 'opacity': 0});
                $('#safety_panel01_s').css({'opacity': 0});
            }
            if(i>=104) {
                $('#safety_panel01_s').css({'opacity': 1});
            }
            // if(tmp_shock[i].srcset) image_shock.srcset = tmp_shock[i].srcset;
        }else if(y>=offset_anpi.top+SIZE_anpi*3){
            $("#safety_panel_bg").css("top","-"+(dy-SIZE_anpi*3))
        }
    });

    $("#safety_padding01").height(SIZE_anpi*7);


    //繝ｯ繝ｳ繧ｿ繝�メ
    var tmp_touch = {};
    loadImageToTmp_touch();
    function loadImageToTmp_touch(){
        for(var i=1;i<=32;i++){
            const _i = i;
            const img = new Image();
            tmp_touch[_i] = null;
            img.src = "https://xs791560.xsrv.jp/concept/images/safety/touch/0"+_i+".webp";
            // img.srcset = "bundles/web/img/concept/shock/0"+_i+"@2x.webp";
            img.addEventListener("load",()=>{
                tmp_touch[_i] = img;
            })
        }
    }

    const image_touch = document.getElementById("safety_panel02_img");

    var SIZE_touch = 32;

    const offset_touch = $("#safety_panel_bg02").offset();
    $(window).scroll(function() {
        const y = $(window).scrollTop()-($('.design').height()+$('.fv').parents('.pin-spacer').height()+$('.c-area').parents('.pin-spacer').height()+$('#safety_lead').parents('.pin-spacer').height()+$('#feature01').parents('.pin-spacer').height());
        const dy = y - offset_touch.top;
        if(offset_touch.top<y&&y<offset_touch.top+SIZE_touch*5){
            const i = Math.floor(dy / 5);
            if(i<=0||i>=SIZE_touch) return;
            if (tmp_touch[i].src) image_touch.src = tmp_touch[i].src;
        }else if(y>=offset_touch.top+SIZE_touch*5){
            $("#safety_panel_bg02").css("top","-"+(dy-SIZE_touch*5))
        }
    });

    $("#safety_padding02").height(SIZE_touch*36);


    //繝輔ャ繧ｯ
    var tmp_hook = {};
    loadImageToTmp_hook();
    function loadImageToTmp_hook(){
        for(var i=1;i<=71;i++){
            const _i = i;
            const img = new Image();
            tmp_hook[_i] = null;
            img.src = "https://xs791560.xsrv.jp/concept/images/safety/hook/0"+_i+".webp";
            // img.srcset = "bundles/web/img/concept/shock/0"+_i+"@2x.webp";
            img.addEventListener("load",()=>{
                tmp_hook[_i] = img;
            })
        }
    }

    const image_hook = document.getElementById("safety_panel03_img");

    var SIZE_hook = 71;

    const offset_hook = $("#safety_panel_bg03").offset();
    $(window).scroll(function() {
        const y = $(window).scrollTop()-($('.design').height()+$('.fv').parents('.pin-spacer').height()+$('.c-area').parents('.pin-spacer').height()+$('#safety_lead').parents('.pin-spacer').height()+$('#feature01').parents('.pin-spacer').height());
        const dy = y - offset_hook.top;
        if(offset_hook.top<y&&y<offset_hook.top+SIZE_hook*12){
            const i = Math.floor(dy / 12);
            if(i<=0||i>=SIZE_hook) return;
            if(tmp_hook[i].src) image_hook.src = tmp_hook[i].src;
        }else if(y>=offset_hook.top+SIZE_hook*12){
            $("#safety_panel_bg03").css("top","-"+(dy-SIZE_hook*12))
        }
    });

    $("#safety_padding03").height(SIZE_hook*24);

}




function lazyLoadVideo01 () {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://xs791560.xsrv.jp/concept/movie/mv01.mp4', true);
    //xhr.responseType = 'blob';
    xhr.onload = function (e) {
        if (this.status === 200) {
            console.log('#mv01 movie is loaded')
            // 繝ｭ繝ｼ繝牙ｮ御ｺ�
            var blob = this.response;
            //var src = ''.createObjectURL(blob);
            $('#mv01').append('<source type="video/mp4" src="https://xs791560.xsrv.jp/concept/movie/mv01.mp4">');
        }
    };
    xhr.send();
}
// 螳溯｡�
lazyLoadVideo01();

// function lazyLoadVideo02 () {
//     var xhr = new XMLHttpRequest();
//     xhr.open('GET', '/bundles/web/mv/mv02.mp4', true);
//     xhr.responseType = 'blob';
//     xhr.onload = function (e) {
//         if (this.status === 200) {
//             // 繝ｭ繝ｼ繝牙ｮ御ｺ�
//             var blob = this.response;
//             var src = (window.webkitURL || window.URL).createObjectURL(blob);
//             $('#mv02').append('<source type="video/mp4" src="' + src + '">');
//         }
//     };
//     xhr.send();
// }
// 螳溯｡�
// lazyLoadVideo02();

function lazyLoadVideo03 () {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://xs791560.xsrv.jp/concept/movie/mv03.mp4', true);
    //xhr.responseType = 'blob';
    xhr.onload = function (e) {
        if (this.status === 200) {
            // 繝ｭ繝ｼ繝牙ｮ御ｺ�
            var blob = this.response;
            //var src = 'https://xs791560.xsrv.jp/concept/movie/mv03.mp4'.createObjectURL(blob);
            $('#mv03').append('<source type="video/mp4" src="https://xs791560.xsrv.jp/concept/movie/mv03.mp4">');
        }
    };
    xhr.send();
}
// 螳溯｡�
lazyLoadVideo03();

function lazyLoadVideo04 () {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://xs791560.xsrv.jp/concept/movie/karui.mp4', true);
    //xhr.responseType = 'blob';
    xhr.onload = function (e) {
        if (this.status === 200) {
            // 繝ｭ繝ｼ繝牙ｮ御ｺ�
            var blob = this.response;
            //var src = 'https://xs791560.xsrv.jp/concept/movie/karui.mp4'.createObjectURL(blob);
            $('#karu').append('<source type="video/mp4" src="https://xs791560.xsrv.jp/concept/movie/karui.mp4">');
        }
    };
    xhr.send();
}
// 螳溯｡�
lazyLoadVideo04();

function lazyLoadVideo05 () {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://xs791560.xsrv.jp/concept/movie/water.mp4', true);
    //xhr.responseType = 'blob';
    xhr.onload = function (e) {
        if (this.status === 200) {
            // 繝ｭ繝ｼ繝牙ｮ御ｺ�
            var blob = this.response;
            //var src = 'https://xs791560.xsrv.jp/concept/movie/water.mp4'.createObjectURL(blob);
            $('#water').append('<source type="video/mp4" src="https://xs791560.xsrv.jp/concept/movie/water.mp4">');
        }
    };
    xhr.send();
}

// 螳溯｡�
lazyLoadVideo05();

$(function () {
    console.log('on ready')
    const offset_a = $('.about').offset().top;
    $(window).scroll(function () {
        if($(window).scrollTop() >= offset_a - $(window).height() + 400 ) {
            $('.org_header').addClass('is_active');
            $('.view-about').addClass('is-show');
            $('#nav_menu_sp').addClass('is_active');
        } else {
            $('.org_header').removeClass('is_active');
            $('#nav_menu_sp').removeClass('is_active');
        }
    });

    setTimeout(function () {
        $('.fv__txt').addClass('is-show');
    }, 1200);

    var l_scr = $(window).scrollTop();

    if(l_scr < 100) {
        $('.loading').fadeIn(1000);
    } else {
        $('.loading').hide();
    }
    var f01 = $('#feature01'),
        // f02 = $('#feature02'),
        f03 = $('#factory'),
        f04 = $('#w-area'),
        f05 = $('#wt-area'),
        v = $('#mv01'),
        v3 = $('#mv03'),
        v4 = $('#karu'),
        v5 = $('#water'),
        scr = $(window).scrollTop();

    var v_st = false;
    var t_st = false;
    var h_st = false;
    $(window).scroll(function () {
        scr = $(window).scrollTop();
        if(scr < 100) {
            $('.loading').fadeIn(1000);
        } else {
            $('.loading').fadeOut(1000);
        }


        if(scr >= $('#about').offset().top - 400 ) {
            $('#about .fadein_trg').addClass('is-show');
        }

        if (f01.offset().top - 300 <= scr + $(window).height()) {
            v.get(0).play();
        } else {
            v.get(0).pause();
        }
        // if (f02.offset().top - 300 <= scr) {
        //     v2.get(0).play();
        // } else {
        //     v2.get(0).pause();
        // }
        if (f03.offset().top - 300 <= scr + $(window).height()) {
            v3.get(0).play();
        }
        if (!v_st && f04.offset().top <= scr + 120) {
            v4.get(0).play();
            v_st = true;
        }
        if (f04.offset().top <= scr + $(window).height()) {
            $('.w-view').css({'transform': 'translate(0, 0)', 'opacity':1 });
            $('.w-area__txt--main').css({'margin-top': 0 });
            setTimeout(function () {
                $('.w-view-after').css({'transform': 'translate(0, 0)', 'opacity':1 });
            },300)
        }
        if (f05.offset().top - 300 <= scr + $(window).height()) {
            v5.get(0).play();
            $('.material .view-ttl').addClass('is-show')
            $('.material .fadein_trg').addClass('is-show')
        } else {
            v5.get(0).pause();
        }

        if($(window).width() < 901) {
            $('.view-ttl').each(function(){
                var elemPos = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > elemPos - windowHeight -80){
                    $(this).addClass('is-show');
                }
            });
            $('.fadein_trg').each(function(){
                var elemPos = $(this).offset().top;
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > elemPos - windowHeight -80){
                    $(this).addClass('is-show');
                }
            });


            var $touch = $('#p_touch'), $hook = $('#p_hook'),
                $v_touch = $('#v_touch'), $v_hook = $('#v_hook');

            if (!t_st && $touch.offset().top <= scr + 300) {
                $v_touch.get(0).play();
                t_st = true;
            }
            if (!h_st && $hook.offset().top <= scr + 300) {
                $v_hook.get(0).play();
                h_st = true;
            }
        }

        $('.fadein, .fadein_right').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight -80){
                $(this).addClass('is-show');
            }
        });

    })

});


if(w < 901) {


    function lazyLoadVideoTouch () {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'https://xs791560.xsrv.jp/concept/movie/v_touch.mp4', true);
        //xhr.responseType = 'blob';
        xhr.onload = function (e) {
            if (this.status === 200) {
                // 繝ｭ繝ｼ繝牙ｮ御ｺ�
                var blob = this.response;
                //var src = 'https://xs791560.xsrv.jp/concept/movie/v_touch.mp4'.createObjectURL(blob);
                $('#v_touch').append('<source type="video/mp4" src="https://xs791560.xsrv.jp/concept/movie/v_touch.mp4">');
            }
        };
        xhr.send();
    }
// 螳溯｡�
    lazyLoadVideoTouch();

    function lazyLoadVideoHook () {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'https://xs791560.xsrv.jp/concept/movie/v_hook.mp4', true);
        //xhr.responseType = 'blob';
        xhr.onload = function (e) {
            if (this.status === 200) {
                // 繝ｭ繝ｼ繝牙ｮ御ｺ�
                var blob = this.response;
                //var src = 'https://xs791560.xsrv.jp/concept/movie/v_hook.mp4'.createObjectURL(blob);
                $('#v_hook').append('<source type="video/mp4" src="https://xs791560.xsrv.jp/concept/movie/v_hook.mp4">');
            }
        };
        xhr.send();
    }
// 螳溯｡�
    lazyLoadVideoHook();
}



